module.exports = __webpack_public_path__ + "static/img/part_06c.5dca0b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pomelo/part_06c.png
// module id = eklM
// module chunks = 6